import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

/**
 * Global error handler that logs unhandled exceptions to the backend.
 * Replaces V1's $exceptionHandler override.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private lastError = '';

  constructor(private injector: Injector) {}

  handleError(error: any): void {
    // Log to console in dev
    console.error('[Portal Error]', error);

    // Prevent duplicate logging of the same error
    const message = error?.message || String(error);
    if (message === this.lastError) return;
    this.lastError = message;

    // Send to backend error log (fire and forget)
    try {
      const http = this.injector.get(HttpClient);
      http.post('/api/datagetter/dg', [{
        action: 'ErrorLog',
        returnas: '',
        message: `[Angular] ${message}`,
        stack: error?.stack?.substring(0, 500) || ''
      }], { withCredentials: true }).subscribe({
        error: () => {} // Silently fail - don't create infinite error loop
      });
    } catch {
      // Can't log - HttpClient not available yet
    }
  }
}
